import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles((theme: any) => ({
    tableContainer: {
        maxHeight: '70vh',
        overflow: 'auto',
    },
    logContent: {
        backgroundColor: theme.palette.action.hover, // #f5f5f5 -> action.hover
        padding: '16px',
        borderRadius: '4px',
        fontSize: '12px',
        overflow: 'auto',
        maxHeight: '300px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        color: theme.palette.text.primary,
    },
}));
